import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getSettingBrandSelfServeOrdersPayments } from "@faire/help-center-utils/settings/getSettingBrandSelfServeOrdersPayments";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Home } from "@faire/web/slate/icons/foundation/Home";
import { Storefront } from "@faire/web/slate/icons/foundation/Storefront";
import React from "react";
import { OTHER_NODES_LABEL } from "../../shared/other-node";
export var useMyShopBrandNodes = function useMyShopBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    MyShop: {
      id: "MyShop",
      label: getSettingBrandSelfServeOrdersPayments() ? strictLocalize({
        id: "p4WAW6",
        defaultMessage: [{
          "type": 0,
          "value": "Winkel beheren"
        }]
      }) : strictLocalize({
        id: "dMUGZU",
        defaultMessage: [{
          "type": 0,
          "value": "Mijn winkel"
        }]
      }),
      icon: getSettingBrandSelfServeOrdersPayments() ? ( /*#__PURE__*/React.createElement(Storefront, {
        fontSize: "24px",
        color: "faireBlack"
      })) : ( /*#__PURE__*/React.createElement(Home, {
        fontSize: "24px",
        color: "faireBlack"
      })),
      children: ["Settings", "OtherMyShop"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "GZDCqb",
        defaultMessage: [{
          "type": 0,
          "value": "Winkelprobleem"
        }]
      })
    },
    Settings: {
      id: "Settings",
      label: strictLocalize({
        id: "iyytHb",
        defaultMessage: [{
          "type": 0,
          "value": "Instellingen"
        }]
      }),
      level: 2
    },
    OtherMyShop: {
      id: "OtherMyShop",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.OptimizingMyPage.PRODUCT_PHOTOGRAPHY_GUIDELINES, articles.OptimizingMyPage.BRAND_STORY_GUIDELINES, articles.OptimizingMyPage.ADD_VIDEO],
      level: 2
    }
  };
};